import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            实时追踪全网热度，精选口碑与流量双赢的高分剧集，帮你告别剧荒
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {rankingItems.map((item, idx) => (
            <div
              key={item.id}
              className="group relative bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="flex items-start gap-4 p-4 md:p-5">
                <div className="relative w-20 h-28 md:w-24 md:h-32 flex-shrink-0 rounded-lg overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={`${item.title} — ${item.subtitle}`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute top-0 left-0 w-7 h-7 bg-primary-500 text-white flex items-center justify-center text-xs font-bold font-label rounded-br-lg">
                    {item.rank}
                  </div>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-label font-semibold text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {item.badge}
                    </span>
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{item.subtitle}</p>
                  <div className="flex flex-wrap items-center gap-1.5 mt-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs text-foreground-600 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                    {item.desc}
                  </p>
                </div>

                <div className="flex flex-col items-center justify-center gap-1 flex-shrink-0">
                  <span className="text-xl font-label font-bold text-primary-500">{item.heat}</span>
                  <span className="text-xs text-foreground-400">评分</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}